import getDeviceInfo from '@/lib/base/getDeviceInfo';
import {CURRENCY_SYMBOL} from '@/constant/currency.js';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    isLoading: false,
    isLoginModalShow: false,
    isNotFound: false,
    viewMode: '',
    device: '',
    orientation: '',
    width: 0,
    height: 0,
    userAgent: null,
    appStyle: {},
    currency: null,
  };
};

const state = initialState();

const getters = {
  loading(state) {
    return state.isLoading;
  },
  notFound(state) {
    return state.isNotFound;
  },
  isLoginModalShow(state) {
    return state.isLoginModalShow;
  },
  currencySymbol(state) {
    return CURRENCY_SYMBOL[state.currency];
  },
  currency(state) {
    return state.currency;
  },
  device(state) {
    const {viewMode, device} = state;
    return {
      isDesktop: viewMode === 'web',
      isTablet: viewMode === 'pad',
      isMobile: viewMode === 'phone',
      isAndroid: device === 'android',
      isIos: device === 'ios',
    };
  },
};

const actions = {
  init({commit}) {
    const data = getDeviceInfo();
    commit('setEnv', data);
    commit('setAppStyle', {height: `${data.height}px`});
  },
};

const mutations = {
  setEnv(state, data) {
    const {viewMode, device, orientation, height, width, userAgent} = data;
    state.viewMode = viewMode;
    state.device = device;
    state.orientation = orientation;
    state.width = width;
    state.height = height;
    state.userAgent = userAgent;
  },
  setIsLoading(state, value) {
    state.isLoading = value;
  },
  setIsNotFound(state, value) {
    state.isNotFound = value;
  },
  setLoginModalShow(state, value) {
    state.isLoginModalShow = value;
  },
  setAppStyle(state, value) {
    state.appStyle = value;
  },
  setCurrency(state, value) {
    state.currency = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
